import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  public currentTheme: BehaviorSubject<string> = new BehaviorSubject<string>(
    'dark-theme',
  );
  public currentTheme$: Observable<string> = this.currentTheme.asObservable();

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);

    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      this.currentTheme.next(storedTheme);
    }
  }

  public setTheme(theme: 'light-theme' | 'dark-theme'): void {
    if (this.currentTheme.value !== theme) {
      this.currentTheme.next(theme);
      localStorage.setItem('theme', theme);
    }
  }

  public applyTheme(theme: string): void {
    this.renderer.removeClass(document.body, 'light-theme');
    this.renderer.removeClass(document.body, 'dark-theme');
    this.renderer.addClass(document.body, theme);
  }
}

